module.exports = __webpack_public_path__ + "static/media/topperformer.5333c7da.JPG";